import Service from "./../../Libs/Service";

//Сервис кластера на клиенте: состояние нод, которое прислал сервер.
//
//Клиент подключается по сокету только к своей ноде, поэтому список нод всего кластера
//собирает нода, к которой подключён супер-админ: она опрашивает остальные ноды и присылает
//готовый список. Данные приходят ключом ClusterNodes (см. Server/Services/Cluster/Cluster.Nodes.mjs)
//и обновляются только при изменении состава нод (подключение или отключение), при подключении
//супер-админа и по запросу окна мониторинга.
//
//Здесь же лежит поток внутренних запросов между нодами (ключ ClusterLog): он приходит только
//супер-админам и только пока открыто окно лога (Server/Services/Cluster/Cluster.Log.mjs).
//
//Ещё здесь хранится рабочая нода - нода, чьи данные сейчас лежат в активных картах сервисов.
//У каждой ноды своя БД, и id сущностей на разных нодах совпадают, поэтому каждый сервис держит
//карты данных отдельно по нодам (Creative.CreativesByServer[serverId] и т.д.), а при переключении
//ноды просто подменяет активные карты (Client/Libs/Service.js, getServerMap). Очистка кэшей не нужна.
let Cluster = new Service({

	Name: "Cluster",

	Actions: {

		"ClusterNodes": function(nodes) {

			this.nodes = nodes || [];

			Broadcast.call("Cluster Nodes Changed", [this.nodes]);

		},

		//Поток запросов между нодами: при открытии окна приходит накопленный список,
		//дальше нода досылает по одной новой записи
		"ClusterLog": function(log) {

			if (log.reset) this.logs = log.entries || [];
			else this.logs = this.logs.concat(log.entries || []);

			Broadcast.call("Cluster Log Changed", [this.logs]);

		}

	},

	init() {

		//Состояние нод кластера (пусто, пока сервер не прислал данные)
		this.nodes = [];

		//Поток запросов между нодами (пусто, пока супер-админ не открыл окно лога)
		this.logs = [];

		//Рабочая нода: нода, данные которой лежат в активных картах сервисов
		this.workingServerId = 0;

	},

	//Нода, данные которой лежат в активных картах сервисов
	getWorkingServerId() {

		return this.workingServerId;

	},

	//Переключаем рабочую ноду: сервисы подменяют активные карты на карты этой ноды
	//(событие Cluster Working Node Changed), сами данные нод при этом остаются в памяти
	useServer(serverId) {

		serverId = serverId || 0;

		if (this.workingServerId === serverId) return;

		let previousServerId = this.workingServerId;

		this.workingServerId = serverId;

		Broadcast.call("Cluster Working Node Changed", [previousServerId, serverId]);

	},

	//Список нод кластера в порядке возрастания номера
	getNodes() {

		return this.nodes;

	},

	//Нода на связи: своя нода и те, с которыми сервер держит соединение
	isOnline(serverId) {

		let node = _.find(this.nodes, node => node.serverId === serverId);

		return !!(node && node.online);

	},

	//Подключён ли клиент к ноде прямо сейчас: первичное соединение - нода аккаунта,
	//вторичные - остальные ноды кластера, к которым админ подключён за списками
	isNodeConnected(serverId) {

		return Server.isConnected(serverId);

	},

	//Поток запросов между нодами (показывается в окне лога супер-админам)
	getLogs() {

		return this.logs;

	},

	//Очищаем окно лога на клиенте (сервер продолжает присылать новые записи)
	clearLogs() {

		this.logs = [];

		Broadcast.call("Cluster Log Changed", [this.logs]);

	}

});

window.Cluster = Cluster;

export { Cluster }
